import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from 'react-bootstrap';

import { User_Certificate_Accred, User_Certificate_Certificate } from "../../../../config/adminUrlConfig";
import { UserCertificate } from "../../../../config/apiServices";

const DigitalCertificates = ({ userData }) => {
    const [certifications, setCertifications] = useState([]);
    const [accreditations, setAccreditations] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        if (!userData?.atom_id) return;
        const atomId = userData.atom_id;

        UserCertificate.get(`${User_Certificate_Certificate}/${atomId}`)
            .then((res) => {
                const data = res?.data;
                setCertifications(Array.isArray(data?.data) ? data.data : []);
            })
            .catch(() => setCertifications([]));

        UserCertificate.get(`${User_Certificate_Accred}/${atomId}`)
            .then((res) => {
                const data = res?.data;
                setAccreditations(Array.isArray(data?.data) ? data.data : []);
            })
            .catch(() => setAccreditations([]));
    }, [userData]);

    const handleViewAllCertificates = () => {
        navigate("/Certificate", { state: { atomId: userData?.atom_id } });
    };

    const handleViewAllAccreditation = () => {
        navigate("/Accreditation", { state: { atomId: userData?.atom_id } });
    };

    return (
        <div className="py-2">
            {/* Certifications */}
            <div className="d-flex justify-content-between align-items-center mb-3 mt-2">
                <h6 className="fw-bold text-dark mb-0 fs-6">Certifications</h6>
                <Button
                    variant="outline-secondary"
                    className="bg-white text-dark btn-sm px-4 py-1 rounded"
                    onClick={handleViewAllCertificates}
                >
                    View All
                </Button>
            </div>

            <div className="table-responsive mb-4 rounded border shadow-sm">
                <table className="table table-borderless align-middle mb-0">
                    <thead style={{ backgroundColor: "#8a61b8", color: "white" }}>
                        <tr>
                            <th className="py-3 ps-4 rounded-top-start fw-medium">Event Name</th>
                            <th className="py-3 text-center fw-medium">Date</th>
                            <th className="py-3 pe-4 text-end rounded-top-end fw-medium">Action</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white">
                        {certifications.length > 0 ? (
                            certifications.map((item, idx) => (
                                <tr key={idx} style={{ borderBottom: "1px solid #f0f0f0" }}>
                                    <td className="ps-4 py-3 fw-medium text-dark">{item.eventName}</td>
                                    <td className="py-3 text-center text-muted">
                                        {new Date(item.createdAt).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })}
                                    </td>
                                    <td className="py-3 pe-4 text-end">
                                        <span className="text-primary fw-medium" style={{ cursor: "pointer" }} onClick={() => window.open(item.link)}>
                                            Download
                                        </span>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="3" className="text-center py-4 text-muted border-top">
                                    <h6 className="mb-0 fw-bold text-dark fs-5">
                                        Data is not available
                                    </h6>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Accreditation */}
            <div className="d-flex justify-content-between align-items-center mb-3 mt-4">
                <h6 className="fw-bold text-dark mb-0 fs-6">Accreditation</h6>
                <Button
                    variant="outline-secondary"
                    className="bg-white text-dark btn-sm px-4 py-1 rounded"
                    onClick={handleViewAllAccreditation}
                >
                    View All
                </Button>
            </div>

            <div className="table-responsive rounded border shadow-sm mb-2">
                <table className="table table-borderless align-middle mb-0">
                    <thead style={{ backgroundColor: "#8a61b8", color: "white" }}>
                        <tr>
                            <th className="py-3 ps-4 rounded-top-start fw-medium">Event Name</th>
                            <th className="py-3 text-center fw-medium">Date</th>
                            <th className="py-3 pe-4 text-end rounded-top-end fw-medium">Action</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white">
                        {accreditations.length > 0 ? (
                            accreditations.map((item, idx) => (
                                <tr key={idx} style={{ borderBottom: "1px solid #f0f0f0" }}>
                                    <td className="ps-4 py-3 fw-medium text-dark">{item.eventName}</td>
                                    <td className="py-3 text-center text-muted">
                                        {new Date(item.createdAt).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })}
                                    </td>
                                    <td className="py-3 pe-4 text-end">
                                        <span className="text-primary fw-medium" style={{ cursor: "pointer" }} onClick={() => window.open(item.link)}>
                                            Download
                                        </span>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="3" className="text-center py-4 text-muted border-top">
                                    <h6 className="mb-0 fw-bold text-dark fs-5">
                                        Data is not available
                                    </h6>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default DigitalCertificates;